import ReplyRoundedIcon from "@mui/icons-material/ReplyRounded";
import documentIconTXT from "../Images/DocumentIconTXT.svg";
import documentIconPDF from "../Images/DocumentIconPDF.svg";
import documentIconDOC from "../Images/DocumentIconDOC.svg";
import documentIconPPT from "../Images/DocumentIconPPT.svg";
import documentIconXLS from "../Images/DocumentIconXLS.svg";
import documentIconRAR from "../Images/DocumentIconRAR.svg";
import documentIconZIP from "../Images/DocumentIconZIP.svg";
import documentIconDefault from "../Images/DocumentIconDefault.svg";
import documentIconMP3 from "../Images/DocumentIconMP3.svg";

const renderBody = (
  RecordID,
  body,
  type,
  fName,
  caption,
  quote,
  preview,
  getmedia
) => {
  const regEx = /[/]..\//g;

  const textFormatter = (text) => {
    let string = text;
    // html formatter
    const htmlFormat = [
      { symbol: "*", tag: "b" },
      { symbol: "_", tag: "em" },
      { symbol: "~", tag: "del" },
      { symbol: "`", tag: "code" },
    ];

    htmlFormat.forEach(({ symbol, tag }) => {
      if (!string) return;
      const regex = new RegExp(`\\${symbol}[^*]+\\${symbol}`);
      const match = string.match(regex);
      if (!match) return;

      match.forEach((m) => {
        let formatted = m;
        for (let i = 0; i < 2; i++) {
          formatted = formatted.replace(symbol, `<${i > 0 ? "/" : ""}${tag}>`);
        }
        string = string.replace(m, formatted);
      });
    });

    return string;
  };

  const NameRegex = /\....*/;
  const tempName = caption;
  let FileNameBody;
  //file64 is changed or removed

  if (caption) {
    const result = tempName.match(NameRegex);
    const limit = 12;
    FileNameBody =
      tempName.length > limit
        ? tempName.substring(0, limit) + "..." + result[0]
        : tempName;
  }

  let retval;
  const media = fName;
  let doctemp;
  if (media) {
    switch (media.substring(media.lastIndexOf(".") + 1)) {
      case "pdf":
        doctemp = documentIconPDF;
        break;
      case "txt":
        doctemp = documentIconTXT;
        break;
      case "xls":
      case "xlsx":
        doctemp = documentIconXLS;
        break;
      case "ppt":
      case "pptx":
        doctemp = documentIconPPT;
        break;
      case "doc":
      case "docx":
        doctemp = documentIconDOC;
        break;
      case "rar":
        doctemp = documentIconRAR;
        break;
      case "zip":
        doctemp = documentIconZIP;
        break;
      case "mp3":
      case "mpga":
        doctemp = documentIconMP3;
        break;
      default:
        doctemp = documentIconDefault;
    }
  }
  if (type === "document") {
    return (
      <div>
        <div style={{ display: "grid" }}>
          <img src={doctemp} alt="" className="documentcss" />
          <span className="ChatRoombBody_caption_reply">{FileNameBody}</span>
        </div>
      </div>
    );
  } else if (type === "video" || type === "image") {
    const text = body;
    return (
      <div>
        <div className="ChatRoombBody_image">
          <img
            src={text}
            alt=""
            onClick={() =>
              preview && getmedia
                ? null
                : getmedia(fName, "admin", type === "video" ? true : false)
            }
            className="imagecss"
          ></img>
          {caption ? (
            <span className="ChatRoombBody_caption">{FileNameBody}</span>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  } else if (quote) {
    const ImagesQ = "data:image/jpeg;base64," + quote;
    let quoteTextFormat;
    quoteTextFormat = textFormatter(body);
    if (regEx.test(quote)) {
      return (
        <div>
          <div className="ChatRoombBody_reply">
            <img src={ImagesQ} alt=""></img>
            <ReplyRoundedIcon
              style={{ width: 10, height: 10, marginRight: -8 }}
            />
          </div>
          <div dangerouslySetInnerHTML={{ __html: quoteTextFormat }}></div>
        </div>
      );
    } else if (!regEx.test(quote)) {
      return (
        <div>
          <div className="ChatRoombBody_reply">
            <span className="ChatRoombBody_caption_reply">{quote}</span>
            <ReplyRoundedIcon
              style={{ width: 10, height: 10, marginRight: -8 }}
            />
          </div>
          <div dangerouslySetInnerHTML={{ __html: quoteTextFormat }}></div>
        </div>
      );
    }
  } else if (type === "ptt") {
    return (
      <div>
        <audio id={type + RecordID} controls />
      </div>
    );
  } else if (type === "sticker") {
    return (
      <div>
        <img id={type + RecordID} alt="" className="stickercss"></img>
        {caption ? (
          <span className="ChatRoombBody_caption">{caption}</span>
        ) : (
          ""
        )}
      </div>
    );
  } else {
    retval = textFormatter(body);
  }

  return (
    <div
      dangerouslySetInnerHTML={{ __html: retval }}
      style={{ whiteSpace: "pre-wrap" }}
    ></div>
  );
};

export default renderBody;
